<div *ngIf="anchorItems.length > 0" class="container-anchor {{ positionType }}" [ngStyle]="{
        'background-color': bgColor,
        'color': color,
        'top': positionTop
    }">
    <div class="container d-flex justify-content-center position-relative">
        <div class="container__general-anchor d-flex flex-nowrap" id="container-general-anchor-{{ styleHeader }}">
            <ng-container *ngFor="let anchorItem of anchorItems; let idx = index">
                <div class="m-auto" [ngClass]="{
                    'header-first-level': styleHeader === 'first',
                    'header-second-level': styleHeader === 'second' || styleHeader === 'second-timeline',
                    'header-collapse': styleHeader === 'collapse',
                    'active-first-level': currentAnchor === anchorItem.idRow && styleHeader === 'first',
                    'active-second-level': currentAnchor === anchorItem.idRow && (styleHeader === 'second' || styleHeader === 'second-timeline'),
                    'active-collapse': currentAnchor === anchorItem.idRow && styleHeader === 'collapse'
                }" (click)="goTarget(anchorItem.idRow, idx)">
                    <p *ngIf="anchorItem.labelRow.length > 1"
                        class="m-0 d-flex w-100 text-center ls-label-medium-semibold cursor-pointer text-uppercase"
                        [innerHTML]="anchorItem.labelRow | translate">
                    </p>
                </div>
            </ng-container>
        </div>
        <div class="container__arrows">
            <ng-container *ngIf="styleHeader === 'first' && activeScroll">
                <div id="slideBack" class="d-flex justify-content-center align-content-center"
                    [ngClass]="{'dark': positionToLeft !== 0}" (click)="back()">
                    <img loading="lazy" src="./assets/images/arrows-anchor/arrow_first_right_active.svg" style="rotate: 180deg;"
                        alt="icon back" [ngStyle]="{'opacity': positionToLeft === 0 ? '0.5' : '1'}">
                </div>
                <div id="slide" class="d-flex justify-content-center align-content-center dark"
                    [ngClass]="{'dark': !isEndScroll}" (click)="next()">
                    <img loading="lazy" src="./assets/images/arrows-anchor/arrow_first_right_active.svg"
                        [ngStyle]="{'opacity': isEndScroll ? '0.5' : '1'}" alt="icon next">
                </div>
            </ng-container>
            <ng-container
                *ngIf="((styleHeader === 'second' || styleHeader === 'second-timeline') && activeScroll) || (styleHeader === 'collapse' && activeScroll) ">
                <div id="slideBack" class="d-flex justify-content-center align-content-center " (click)="back()"
                    [ngClass]="{'light': positionToLeft !== 0}" (click)="back()">
                    <img loading="lazy" src="./assets/images/arrows-anchor/arrow_second_right_active.svg" style="rotate: 180deg;"
                        alt="icon back" [ngStyle]="{'opacity': positionToLeft === 0 ? '0.5' : '1'}">
                </div>
                <div id="slide" class="d-flex justify-content-center align-content-center"
                    [ngClass]="{'light': !isEndScroll}" (click)="next()">
                    <img loading="lazy" src="./assets/images/arrows-anchor/arrow_second_right_active.svg"
                        [ngStyle]="{'opacity': isEndScroll ? '0.5' : '1'}" alt="icon next">
                </div>
            </ng-container>
        </div>
    </div>
</div>